import React, { Component } from 'react';

import { number, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';

import FileUploaderStatus from '../../file/file-uploader-status';

import './progress-bar.scss';

class ProgressBar extends Component {

  static propTypes = {
    failedUploadExpression: string,
    progress: number,
    size: number,
    status: string,
  };

  static defaultProps = {
    progress: 0,
    status: '',
  };

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  render() {
    const { status, progress, size, failedUploadExpression } = this.props;

    if (status == FileUploaderStatus.DONE) {
      return (
        <span className="c-file__size" > { this.formatBytes(size) } </span>
      );
    }

    if (status == FileUploaderStatus.ERROR) {
      return  <span className="c-file__failed" > { msg(failedUploadExpression) } </span>;
    }

    const style = {
      width: `${progress}%`,
    };

    return (
      <div className="c-file-progress">
        <div className={`c-file-progress__${status}`} style={style} />
      </div>
    );
  }
}

export default ProgressBar;
